export default __webpack_public_path__ + "static/media/sticker-W.14a5c112.png";